import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageSEO from '@/components/feature/PageSEO';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import FeaturesSection from './components/FeaturesSection';
import GridCardsSection from './components/GridCardsSection';
import CTASection from './components/CTASection';
import TestimonialsSection from './components/TestimonialsSection';
import { heroData, featuresData, gridCardsData, testimonialData, statsData, ctaData } from '@/mocks/homeData';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'NOPAY钱包',
  alternateName: 'NOPAY Wallet',
  url: 'http://dajiang03.cn/',
  description: 'NOPAY钱包官方网站，2026国际足联世界杯(FIFA World Cup 2026)官方合作伙伴。坚持用户体验至上、技术引领理念，构建全球领先的安全公平、稳健高效的数字化娱乐殿堂。',
  inLanguage: 'zh-Hans',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://dajiang03.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <PageSEO
        title="首页"
        description="NOPAY钱包官方网站，2026国际足联世界杯(FIFA World Cup 2026)官方合作伙伴。金融级防护体系与24/7全时金牌客服。"
        keywords="NOPAY钱包,NOPAY,2026世界杯,FIFA World Cup 2026,数字化娱乐,安全支付,数字钱包"
        canonicalUrl="http://dajiang03.cn/"
        schemaJson={homeSchema}
      />

      <Navbar />

      <main>
        <HeroSection
          title={heroData.title}
          subtitle={heroData.subtitle}
          description={heroData.description}
          ctaLabel={heroData.ctaLabel}
          ctaUrl={heroData.ctaUrl}
          heroImage={heroData.heroImage}
        />

        <StatsSection stats={statsData} />

        <FeaturesSection features={featuresData} />

        <GridCardsSection cards={gridCardsData} />

        <CTASection
          title={ctaData.title}
          description={ctaData.description}
          subDescription={ctaData.subDescription}
          ctaLabel={ctaData.ctaLabel}
          ctaUrl={ctaData.ctaUrl}
          bgImage={ctaData.bgImage}
        />

        <TestimonialsSection testimonials={testimonialData} />
      </main>

      <Footer />
    </>
  );
}